<div class="slider_lateral" [class]="className">
	<div class="content_detalle">
		<a class="close_detalle" (click)="overlayClicked()"><img src="assets/images/icon_cerrar.png" alt="cerrar" /></a>
		<h2>
			{{ title }}<strong>{{ titleStrong }}</strong>
		</h2>
		<ng-template appInsertion></ng-template>
	</div>
</div>
<div class="overlay_detalle" (click)="overlayClicked()"></div>
